import React, { useState, useEffect } from "react";
import style from "css/mobile/qr.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, ConfigProvider, Drawer } from "antd";
import { ReactComponent as CheckInIcon } from "asset/mobile/checkin.svg";
import QRScannerComponent from "./qrScan";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { openAlert, openConfirm, closeAlert } from "redux/slices/alertSlice";
import axios from "axios";
import dayjs from "dayjs";
import { createBrowserHistory } from "history";
import useModalWithHistory from "function/useModalWithHistory";

function Qr() {
  const { t } = useTranslation();
  //dispatch
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  //history
  const history = createBrowserHistory();

  //navigate
  const navigate = useNavigate();

  //selector
  const payload = useSelector((state) => state.user);

  const [isOpen, handleOpen] = useModalWithHistory(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const openQrSacnner = () => {
    window.history.pushState(null, "", window.location.href);
    handleOpen(true);
  };

  const closeQrScanner = () => {
    handleOpen(false);
  };

  const [bookTime, setBookTime] = useState({
    start: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    end: dayjs().set("hour", 18).set("minute", 0).format("YYYY-MM-DD HH:mm:ss"),
  });

  const handleScanQrCode = (id, type) => {
    if (id !== "" && type === null) {
      let config = {
        params: {
          // member_id: userId,
          resource_id: id,
        },
      };
      axios.get("/hotdesking/book/list/current", config).then((res) => {
        if (res.status === 200) {
          if (res.data.length > 0) {
            const bookMemberId = res.data[0].member.id;
            const bookStatus = res.data[0].status;
            if (bookStatus !== "IN_USE") {
              if (bookMemberId === payload.id) {
                const obj = {
                  title: t("MESSAGE.NOTIFICATION"),
                  content: "예약한 좌석입니다. 바로 체크인 하시겠습니까?",
                  submitEventHandler: () => {
                    dispatch(closeAlert());
                    const axiosData = {
                      params: {
                        book_id: res.data[0].id,
                        status: "IN_USE",
                      },
                    };
                    axios
                      .put("/hotdesking/book/status", null, axiosData)
                      .then((res) => {
                        if (res.status === 200) {
                          const obj = {
                            title: t("MESSAGE.NOTIFICATION"),
                            content: "체크인이 완료되었습니다.",
                            submitEventHandler: () => dispatch(closeAlert()),
                          };
                          dispatch(openAlert(obj));
                        }
                      })
                      .catch((err) => {
                        const obj = {
                          title: t("MESSAGE.NOTIFICATION"),
                          content: "체크인 과정 중 오류가 발생하였습니다.",
                          submitEventHandler: () => dispatch(closeAlert()),
                        };
                        dispatch(openAlert(obj));
                      });
                  },
                  cancelEventHandler: () => {
                    dispatch(closeAlert());
                  },
                };
                dispatch(openConfirm(obj));
              } else {
                const obj = {
                  title: t("MESSAGE.NOTIFICATION"),
                  content:
                    "다른 사용자가 예약한 좌석입니다. 다른 좌석을 이용해주시기 바랍니다.",
                  submitEventHandler: () => dispatch(closeAlert()),
                };
                dispatch(openAlert(obj));
              }
            } else {
              const obj = {
                title: t("MESSAGE.NOTIFICATION"),
                content:
                  "현재 사용 중인 좌석입니다. 다른 좌석을 이용해주시기 바랍니다.",
                submitEventHandler: () => dispatch(closeAlert()),
              };
              dispatch(openAlert(obj));
            }
          } else if (res.data.length === 0) {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: "빈 좌석입니다. 바로 체크인 하시겠습니까?",
              submitEventHandler: () => {
                dispatch(closeAlert());

                const axiosData = {
                  resource_id: id,
                  // location_id: "20250318000001",
                  start_dttm: bookTime.start,
                  end_dttm: bookTime.end,
                  status: "IN_USE",
                };
                axios
                  .post("/hotdesking/book", axiosData)
                  .then((res) => {
                    if (res.status === 200) {
                      const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: "체크인이 완료되었습니다.",
                        submitEventHandler: () => dispatch(closeAlert()),
                      };
                      dispatch(openAlert(obj));
                    }
                  })
                  .catch((err) => {
                    const obj = {
                      title: t("MESSAGE.NOTIFICATION"),
                      content: "체크인 과정 중 오류가 발생하였습니다.",
                      submitEventHandler: () => dispatch(closeAlert()),
                    };
                    dispatch(openAlert(obj));
                  });
              },
              cancelEventHandler: () => {
                dispatch(closeAlert());
              },
            };
            dispatch(openConfirm(obj));
          }
        }
      });
    } else if (id !== "" && type !== null) {
      let config = {
        params: {
          // member_id: userId,
          ENDPOINT_ID: id,
        },
      };
      axios.get("/schedule/pad/checkin", config).then((res) => {
        if (res.status === 200) {
          if (res.data.result) {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: res.data.msg,
              submitEventHandler: () => {
                dispatch(closeAlert());
                const axiosData = {
                  params: {
                    ENDPOINT_ID: id,
                  },
                };
                axios
                  .post("/schedule/pad/checkin", null, axiosData)
                  .then((res) => {
                    if (res.status === 200) {
                      const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: "체크인이 완료되었습니다.",
                        submitEventHandler: () => dispatch(closeAlert()),
                      };
                      dispatch(openAlert(obj));
                    }
                  })
                  .catch((err) => {
                    const obj = {
                      title: t("MESSAGE.NOTIFICATION"),
                      content: "체크인 과정 중 오류가 발생하였습니다.",
                      submitEventHandler: () => dispatch(closeAlert()),
                    };
                    dispatch(openAlert(obj));
                  });
              },
              cancelEventHandler: () => {
                dispatch(closeAlert());
              },
            };
            dispatch(openConfirm(obj));
          } else {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: res.data.msg,
              submitEventHandler: () => {
                dispatch(closeAlert());
              },
            };
            dispatch(openAlert(obj));
          }
        }
      });
    }
  };

  useEffect(() => {
    console.log(searchParams);
    const id = searchParams.get("id");
    const type = searchParams.get("type");
    if (id !== null) {
      if (payload.id !== "") {
        //로그인 되어있음
        closeQrScanner();
        handleScanQrCode(id, type);
        //체크인 유무 및 본인 체크인 확인
      } else {
        //비로그인 로그인 페이지로 이동
        navigate(
          type !== null
            ? process.env.REACT_APP_CLIENT_URL + "?id=" + id + "&type=" + type
            : process.env.REACT_APP_CLIENT_URL + "?id=" + id
        );
      }
    }
  }, [searchParams]);

  return (
    <>
      <div className={style.wrapper}>
        <div className={style.container}>
          <Button
            className={style.qr_check_in_btn}
            onClick={() => openQrSacnner()}
            type="primary"
            icon={<CheckInIcon />}
          >
            {t("BTN.CHECK_IN")}
          </Button>
          <ConfigProvider
            theme={{
              components: {
                Drawer: {
                  padding: 0,
                },
              },
            }}
          >
            <Drawer
              className="qr_scan_drawer"
              open={isOpen}
              // closable={false}
              width="100%"
              height="100%"
              style={{
                padding: 0,
              }}
              placement="bottom"
            >
              <QRScannerComponent
                open={isOpen}
                close={closeQrScanner}
                scan={handleScanQrCode}
              />
            </Drawer>
          </ConfigProvider>
        </div>
      </div>
    </>
  );
}

export default Qr;
